export default __webpack_public_path__ + "static/fitness-interno-3515aeb7c738035fad3ff22faafe6596.jpg";